import { render, staticRenderFns } from "./ModalNewsletter.vue?vue&type=template&id=2afe614b"
import script from "./ModalNewsletter.vue?vue&type=script&lang=js"
export * from "./ModalNewsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsEnvelope: require('/home/forge/farescraper.com/components/IconsEnvelope.vue').default,AppModal: require('/home/forge/farescraper.com/components/AppModal.vue').default})
